import { NavLink, useLocation, Link } from "react-router-dom";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { CustomerServiceOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { clearFilter, fetchRequest } from "../../store/actions/asset";
import { clearFilter as alertClearFilter } from "../../store/actions/alertsGroup";

const NavMenu = (props) => {
  const { menuItems, left } = props;
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  // we are removing the selected filter value from the session
  const onClear = () => {
    sessionStorage.removeItem("state");
    sessionStorage.removeItem("status");
    sessionStorage.removeItem("shipmentName");
    sessionStorage.removeItem("startDate");
    sessionStorage.removeItem("lastUpdated");
  };

  const handleNavLinkClick = (path) => {
    if (path === "/alerts") {
      dispatch(alertClearFilter());
    }
    if (path === "/assets") {
      dispatch(clearFilter());
      dispatch(fetchRequest());
    }
  };
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
    },
  }));
  return (
    <div
      className="sasp_nav-menu sasp_vz-nhg-eds-font"
      style={{ color: "#000" }}
    >
      <ul
        style={{
          listStyle: "none",
          padding: "0px",
          paddingLeft: "2px",
          marginTop: "-4.8px",
        }}
      >
        {menuItems.map((item) => {
          return (
            <li key={item} style={{ margin: "0px 0px" }}>
              <NavLink
                onClick={() => handleNavLinkClick(item?.path)}
                to={item?.path}
                className={
                  pathname.includes(item?.path)
                    ? "sasp_active-menu-link"
                    : "sasp_inactive-menu-link"
                }
                end
              >
                <BootstrapTooltip title={item.name} placement="right">
                  <div
                    onClick={onClear}
                    className="sasp_text-overflow-ellipsis"
                    style={{ padding: "8px 15px", paddingRigh: "0px" }}
                    title={item.name}
                  >
                    {item?.whiteIcon && (
                      <img
                        alt="profile-user"
                        width="20px"
                        height={"20px"}
                        src={item.whiteIcon}
                      />
                    )}
                    {/* {item?.name === "Support" ? (
                      <CustomerServiceOutlined
                        style={{
                          color: "rgb(255, 255, 255)",
                          height: "20px",
                          width: "20px",
                        }}
                      />
                    ) : (
                      ""
                    )} */}
                    {!left && (
                      <span
                        style={{
                          color: "#fff",
                          paddingLeft: "10px",
                          verticalAlign: "middle",
                        }}
                      >
                        {item.name}
                      </span>
                    )}
                  </div>
                </BootstrapTooltip>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
export default NavMenu;
